/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTrayElevationTagModule } from './cable-tray-elevation-tag.module';
export { CableTrayElevationTagComponent } from './cable-tray-elevation-tag.component';